export default __webpack_public_path__ + "static/media/cronaswap.a4f7cf0d.svg";